import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { AppFreeAnswerParameters } from 'altru-types';

@Module({ namespaced: true })
export default class StatusModule extends VuexModule {
  isInIframe = false;
  iframeParent: AppFreeAnswerParameters['source'] | null = null;
  iframeIsAdmin = false;
  originalUrlValue = '';
  initialRedirectDoneValue = false;

  get isIframed(): boolean {
    return this.isInIframe;
  }

  get iframeSource(): AppFreeAnswerParameters['source'] | null {
    return this.iframeParent;
  }

  get iframeParentIsAdminApp(): boolean {
    return this.iframeParent === 'admin';
  }

  get originalUrl(): string {
    return this.originalUrlValue;
  }

  get initialRedirectDone(): boolean {
    return this.initialRedirectDoneValue;
  }

  @Mutation
  setIsInIframe(value: boolean): void {
    this.isInIframe = value;
  }

  @Mutation
  setIframeSource(value: AppFreeAnswerParameters['source']): void {
    this.iframeParent = value;
  }

  @Mutation
  storeOriginalUrl(value: string): void {
    this.originalUrlValue = value;
  }

  @Mutation
  setInitialRedirectDone(value: boolean): void {
    this.initialRedirectDoneValue = value;
  }
}
